import React from 'react'
import WrapPageElement from './wrap'

import "bootstrap/dist/css/bootstrap.min.css"

export const wrapPageElement = ({ element, props }) => {
  return <WrapPageElement element={element} props={props} />
}

